import { render, staticRenderFns } from "./MultiplePay.vue?vue&type=template&id=38dea838&scoped=true"
import script from "./MultiplePay.vue?vue&type=script&lang=js"
export * from "./MultiplePay.vue?vue&type=script&lang=js"
import style0 from "./MultiplePay.vue?vue&type=style&index=0&id=38dea838&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dea838",
  null
  
)

export default component.exports